import { Text } from "@react-pdf/renderer";
import React, { FunctionComponent } from "react";

const MaterialHeader: FunctionComponent<{ label: string }> = ({ label }) => (
  <Text
    style={{
      textAlign: "center",
      fontFamily: "Mont-Bold",
      fontSize: "14px",
      marginTop: "40px",
    }}
  >
    {label}
  </Text>
);

export default MaterialHeader;
